module.exports = __webpack_public_path__ + "static/media/party-catering-1.484bfbe0.jpg";